const blockedTenantDialog = {
    title: 'Esse Ambiente foi bloqueado',
    text: 'Esse ambiente foi descontinuado ou bloqueado, todas as funcionalidades estarão desativadas, caso dúvidas, chamar o suporte',
  }
  
  export default blockedTenantDialog;
  